import { useEffect } from "react";
import DarkCTA from "../components/cta/DarkCTA";
import { FeaturesOne } from "../components/features/FeaturesOne";
import FooterOne from "../components/footer/FooterOne";
import { Header } from "../components/header/Header";
import { Hero } from "../components/hero/Hero";
import { MarketsOne } from "../components/markets/MarketsOne";
import { SecurityOne } from "../components/security/SecurityOne";
import StatsTwo from "../components/stats/StatsTwo";
import { TestimonialOne } from "../components/testimonials/TestimonialOne";
import { TickerTape } from "react-ts-tradingview-widgets";

const Main = () => {
  useEffect(() => {
    function removeTickers() {
      const ticker = document.querySelectorAll("#tradingview_widget_wrapper");
      ticker?.forEach((tick) => {
        tick.lastChild.style.display = "none";
      });
    }

    removeTickers();

    return () => {
      removeTickers();
    };
  });

  const tickerSymbols = [
    {
      proName: "BITSTAMP:BTCUSD",
      title: "BTC/USD",
    },
    {
      proName: "BITSTAMP:ETHUSD",
      title: "ETH/USD",
    },
    {
      proName: "FOREXCOM:SPXUSD",
      title: "S&P 500",
    },
    {
      proName: "FOREXCOM:NSXUSD",
      title: "Nasdaq 100",
    },
    {
      proName: "FX_IDC:EURUSD",
      title: "EUR/USD",
    },
  ];

  return (
    <>
      <div style={{ backgroundColor: "#0c0f19" }}>
        <Header />
        <Hero />
        <TickerTape colorTheme="light" symbols={tickerSymbols}></TickerTape>
      </div>
      <FeaturesOne />
      <div
        style={{
          backgroundColor: "#0c0f19",
          padding: "12px 0px",
        }}
      >
        <StatsTwo />
      </div>
      <SecurityOne />
      <MarketsOne />
      <TestimonialOne />
      <DarkCTA />
      <FooterOne />
      {/* <FeaturesTwoWithImage /> */}
      {/* <HeroFive /> */}
      {/* <HeaderFive /> */}
      {/* <HeaderThree /> */}
      {/* <HeroFour /> */}
      {/* <HeroThree /> */}
      {/* <FeaturesTwoWithImage /> */}
      {/* <FeaturesThree /> */}
      {/* <StatsOne /> */}

      {/* <TestimonialTwo /> */}
      {/* <div style={{ backgroundColor: "#0c0f19" }}>
        <CTATwo />
      </div> */}
      {/* <CTATwo /> */}
      {/* <CTAOne /> */}
      {/* <CTAFour /> */}
      {/* <CTAThree /> */}
    </>
  );
};

export default Main;
